import _ from 'underscore';
import Handlebars from 'handlebars';
import GenericView from 'js/views/generic.view';
import PaginatedView from 'js/views/pagination.view';
import i18n from 'l10n';
import dhtmlx from 'dhtmlxAdapter';
import {debounce, el, model, on, tagName, template} from "../adapters/backbone-decorators";
import QRCode from "qrcode";

import Template from 'js/templates/woo.users.hbs';
import ApiKeyUsersCollection from 'js/models/apiKeyUsers.paginated.collection';
import ApiKeyUsersModel from 'js/models/apiKeyUsers.model';

import ApiKeyUsersPartialTemplate from 'js/templates/partials/apiKeyUsers.partial.hbs';

@el(".tabs")
@model(ApiKeyUsersModel)
@tagName("ul")
@template(Template)
class ApiKeyUsersGenericView extends GenericView {

    constructor(options) {
        super(options);

        this.apiKeyUsersPartialTemplate = Handlebars.compile(ApiKeyUsersPartialTemplate);

        this.collectionUrl = ApiKeyUsersModel.prototype.urlRoot;
        this.collection = new ApiKeyUsersCollection();
        this.collection.url = `${this.collectionUrl}/${this.userRole}`;
        this.collection.on('sync', () => this.addAll(), this);

        if (this.pagination) this.pagination.remove();

        this.pagination = new PaginatedView({collection: this.collection});
        this.pagination.render();

        //this.renderCollection();
    }

    get userRole() {
        return 'ApiKey';
    }

    get className() {
        return '';
    }

    render() {

        this.renderPagination(this.pagination, this.collection, '#pagination');
        this.showHideNoFoundRedeemers(this.collection.count);

        return this;
    }

    renderPagination(pagination, collection, elem) {
        if (pagination) {
            pagination.remove();
        }

        pagination = new PaginatedView({collection: collection});
        pagination.render();
        // Replace view's pagination
        this.$(elem).html(pagination.$el);
    }

    async renderCollection() {
        const response = await this.collection.getFirstPage();
        $(this.el).html(this.template({users: response.data, count: response.count, searchTerm: this.searchText}));
        this.render();
        if (this.searchText) {
            var $usersSearchBox = this.$('.usersSearchBox');
            $usersSearchBox.val(this.searchText);
            $usersSearchBox.focus();
        }
        this.$el.find('#email').on("input", event => this.emailOnEdit(event));

    }

    showHideNoFoundRedeemers(totalFound) {
        const notFound = totalFound === 0;
        this.$(".usersTable").toggle(!notFound);
    }

    addAll() {
        this.$(".usersTable").find("tr.row-of-history").remove(); //remove all `<tr>` children, except the `headers` one
        _.each(this.collection.data, item => this.addOne(item));
        this.render();
    }

    addOne(item) {
        const $newRow = $("<tr class='row-of-history'>");
        const attrs = item.attributes ? item.attributes : item;
        const tempTemplate = this.apiKeyUsersPartialTemplate(attrs);
        $newRow.css('font-weight', 400)
            .data('user-id', attrs.id)
            .html(tempTemplate);

        $(this.$(".usersTable")).append($newRow);
    }

    toggleVisibilityOfElement(element, display) {
        if (display === "toggle") $(element).toggle();
        else $(element).css("display", display);
    }

    @on('keyup .description')
    enterDescription(evt) {
        if (evt.which === 13) {
            this.$(".submitNewUserInfo").trigger("click");
        }
    }

    emailIsValid() {
        var message = this.$el.find("#invalid-email-message");
        var createButton = this.$el.find("#create-button");
        message.empty();
        message.hide();
        createButton.removeAttr("disabled");
    }

    emailIsInvalid() {
        var message = this.$el.find("#invalid-email-message");
        var createButton = this.$el.find("#create-button");
        message.text(i18n.t("passwordrecover.notvalidmail"));
        message.show();
        createButton.attr("disabled", "disabled");
    }

    @on('click .createApiUser')
    showNewApiUserForm() {
        this.$(".newApiUserForm").show();
    }

    toggleNewUserButton(toDisable) {
        this.$(".description").attr("disabled", toDisable); //Description Input
        this.$(".email").attr("disabled", toDisable);
        this.$(".cancelCreationOfApiUser").attr("disabled", toDisable); //cancel (close form window) button
        this.$(".submitNewUserInfo").attr("disabled", toDisable); //submit new Redeemer button
        this.$(".redeemerSpinner").toggle(!toDisable); //spinner
    }

    async createUser(postData) {
        try {
            const response = await $.ajaxDefaultQ({
                url: `${this.collectionUrl}/${this.userRole}/create`,
                type: 'POST',
                data: $.param(postData)
            });

            if (response.outcome.outcome === "OK") {
                $.Notify.show(i18n.t("voucher.redeemerCreatedSuccessfully"));

                this.renderCollection();

                this.$(".newApiUserForm").hide();
            } else if (response.outcome.outcome !== "Error")
                dhtmlx.alert(i18n.t(`voucher.redeemer${response.outcome.outcome}`));
            else
                dhtmlx.alert(`Error: ${response.outcome.data}`);

            this.toggleNewUserButton(false);
            if (response.outcome === "OK")
                this.$(".newApiUserForm").hide();
        } catch (e) {
            console.error(e);
            dhtmlx.alert(e);

            this.toggleNewUserButton(false);

        }
    }

    emailOnEdit(event) {
        var re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i;
        if (re.test($(event.currentTarget).val())) {
            this.emailIsValid();
        } else {
            this.emailIsInvalid();
        }
    }

    @on('click .cancelCreationOfApiUser')
    cancelCreationOfApiUser() {
        this.$(".description").val('');
        this.$(".email").val('');

        this.$(".newApiUserForm").hide();
    }

    @on('click .removeUser')
    async removeUser(evt) {

        //event is bound on the <i> element.    parent().parent() get's the current <tr>, which contains the userId
        var userRow = $(evt.currentTarget).closest('[data-user-id]');
        var userId = parseInt($(userRow).attr("data-user-id"));

        var title = this.userRole == "Woo" ? i18n.t("voucher.confirmShopRemovalTitle") : i18n.t("voucher.confirmRedeemerRemovalTitle")
        var text = this.userRole == "Woo" ? i18n.t("voucher.confirmShopRemoval") : i18n.t("voucher.confirmRedeemerRemoval")

        const result = await dhtmlx.modalbox({
               title: title,
               text: text,
               buttons: [i18n.t("message.yes"), i18n.t("message.no")]
         });

        if (result === '0') {
            try {
                const response = await $.ajaxDefaultQ({
                    url: `${this.collectionUrl}/${userId}/remove`,
                    type: 'DELETE'
                });
                if (response.outcome === "OK") {
                    const textKeyToShow = this.userRole == "Woo" ? "voucher.shopRemovedSuccessfully" : "voucher.redeemerRemovedSuccessfully";
                    const inactiveKeyToShow = this.userRole == "Woo" ? "voucher.inactiveShop" : "voucher.inactiveRedeemer";

                    $.Notify.show( i18n.t(textKeyToShow) );

                    const statusIcon = $(userRow).find(".userStatus");
                    if (statusIcon) {

                        $(statusIcon).removeClass('icon-checkmark fg-emerald').addClass('icon-cancel-2 fg-red');
                        $(statusIcon).attr("title", i18n.t( inactiveKeyToShow ));

                        var updatedApiKeyUser = this.collection.data.find(({id}) => id === userId);

                        updatedApiKeyUser.status = false;
                        updatedApiKeyUser.apiKey = null;

                        // update the collection's model, with the new status, so it can be used in the Dialog shown on Redeemers Tab
                        this.collection.set({updatedApiKeyUser},{remove: false})

                        $(userRow).find('.redeemerApiKey').text('');
                        $(userRow).find(".removeUser").hide();
                    }
                } else if (response.outcome !== "Error")
                    dhtmlx.alert(i18n.t(`voucher.redeemer${response.outcome}`));
                else
                    dhtmlx.alert(`Error: ${response.data}`);
            } catch (e) {
                console.error(e);
                dhtmlx.alert(e);

            }

        }

    }

    refreshUser(userId, changedModel) {
        const user = this.collection.data.find(({id}) => id === userId);
        _.extend(user, changedModel);
        const replacement = this.apiKeyUsersPartialTemplate(user);
        this.$(`[data-user-id=${userId}]`).html(replacement);
    }

    async refreshKey(userId) {
        try {
            const response = await $.ajaxDefaultQ({
                url: `${this.collectionUrl}/${userId}/refreshKey`,
                type: 'GET'
            });
            if (response.outcome.outcome === "OK") {

                if(this.userRole == "Woo") {
                    // remove the trailing user id and dash
                    const apiKey = response.apiKey.substring(response.apiKey.indexOf("-") + 1);
                    response.apiKey = apiKey;
                }

                // change the status response
                response.status = true;

                //refresh popup apiKey
                this.refreshUser(userId, response);
                $("#currentRedeemerKey").text(response.apiKey); //refresh api key on Redeemer Information

                const url = 'https://www.tellody.com/getapp?key=' + response.apiKey;
                $("#currentRedeemerUrl").text(url); //refresh getApp url
                $("#qrCodeApiKey").data("link", url); //refresh QR link

                $("#qrCodeApiKey").show();
                $("#autoLoginLink").show();

                const qrImageUrl = await QRCode.toDataURL(response.apiKey, {scale: 7});
                $("#redeemerApiKeyQRCode").attr("src", qrImageUrl); //refresh QR image

                const textKeyToShow = this.userRole == "Woo" ? "voucher.shopKeyRefreshed" : "voucher.redeemerKeyRefreshed";

                $.Notify.show( i18n.t(textKeyToShow) );

            } else if (response.outcome.outcome !== "ERROR")
                dhtmlx.alert(i18n.t(`voucher.redeemer${response.outcome.outcome}`));
            else
                dhtmlx.alert(`Error: ${response.error.data}`);

        } catch (e) {
            console.error(e);
            dhtmlx.alert(e);
        }
    }

    @on('click .refreshUserKey')
    async refreshKeyHandler(evt) {
        //event is bound on the <i> element.     `elem.parent().parent()` get's the current <tr>, which contains the userId
        const currentRedeemerRow = $(evt.currentTarget).closest('[data-user-id]');
        const userId = parseInt($(currentRedeemerRow).attr("data-user-id"));

        await this.refreshKey(userId, this.userRole);
    }

    @on('keyup .usersSearchBox')
    @debounce(800)
    searchUsersByFilter() {
        this.filter = $('.usersSearchBox').val();
        this.$('.usersSearchBox').each((index, elem) => {
            var val = $(elem).val() ? $.trim($(elem).val()).length > 0
                ? $(elem).val() : null
                : null;
            if (val) {
                var text = val.toLowerCase();
                text = text.replace(/^.*-/, "");
                this.searchText = text;
                this.collection.url = `${this.collectionUrl}/${this.userRole}?filtersMap=${text}`;
            } else {
                this.searchText = "";
                this.collection.url = `${this.collectionUrl}/${this.userRole}`;
            }
            this.renderCollection();
        });
    }

}

export default ApiKeyUsersGenericView;
